import React, { useState } from "react";
import { useTranslation } from "react-i18next";

//components to be imported
import EnterpriseComponent from "../Enterprise/EnterpriseComponent";
import CorporateTrainingComponent from "../Enterprise/CorporateTrainingComponent";
import WhiteLableSolutionComponent from "../Enterprise/WhiteLableSolutionComponent";

function WhiteLabelIntro() {
  const [val, setVal] = useState(0);
  const { t } = useTranslation();
  const data = [
    {
      key: 0,
      label: t("corpTraining"),
      desc: "Elevate your workforce and reduce onboarding costs, with our customizable LMS for seamless corporate training and professional development.",
      learnMore: t("learnMore"),
      link: "/corporate-training",
      icon: "icon ",
      component: <CorporateTrainingComponent />,
    },
    {
      key: 1,
      label: t("For Post Secondary"),
      desc: "Expand your revenue streams while providing exceptional professional development. Discover the power of yslearn.in for your organization.",
      learnMore: t("learnMore"),
      link: "/post-secondary",
      icon: "icon ",
      component: <EnterpriseComponent />,
    },
    {
      key: 2,
      label: t("whiteLabelSols"),
      desc: "Make our LMS your own with yslearn.in's white label solutions. Deliver a branded learning experience with your logo and brand colors customized to your needs to set your organization apart!",
      learnMore: t("learnMore"),
      link: "/white-label-solutions",
      icon: "icon ",
      component: <WhiteLableSolutionComponent />,
    },
  ];
  return (
    <section className="whiteLabel">
      <div className="inner-wrapper">
        <div className="tab-left">
          <div className="whitelabel-title">
            {t("For Enterpirse WhiteLabel Intro1")}
            <span>{t("For Enterpirse WhiteLabel Intro2")}</span>
          </div>

          <ul>
            {data.map((item) => {
              return (
                <li
                  key={item.key}
                  style={{ cursor: "pointer" }}
                  className={val === item.key ? "active" : ""}
                  onClick={() => setVal(item.key)}
                >
                  <div>
                    <div className="label-title">{item.label}</div>
                    <div className="label-desc">
                      <p>{item.desc}</p>
                      {/* <p>
                        <a href={item.link}>{item.learnMore}</a>
                      </p> */}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="tab-right">{data[val].component}</div>
      </div>
    </section>
  );
}

// extended main view with translate hoc
//export default translate("translations")(HeroBanner);
export default WhiteLabelIntro;
